<div class="field-group"
     [class.origami-updated]="isUpdatedByOrigami"
>

  <p-iftalabel class="w-full">
    @if (control(); as ctrl) {
      <p-select
        class="w-full"
        [attr.required]="showRequiredHint ? '' : null"
        [dataKey]="dataKey()"
        [editable]="editable()"
        [filterBy]="optionLabel()"
        [filter]="filter()"
        [formControl]="ctrl"
        [id]="inputId()"
        [invalid]="showInvalidState"
        [optionLabel]="optionLabel()"
        [optionValue]="optionValue()"
        [options]="options()"
        [placeholder]="placeholder()"
        (onFilter)="filterEvent.emit($event)"
        (onShow)="showEvent.emit()"
      />
    }

    <label class="block font-medium mb-1"
           [for]="inputId()"
    >
      {{ label() }}
    </label>
  </p-iftalabel>
  @if (showRequiredHint) {
    <small class="block text-red-500 text-xs mt-1">{{ label() }} is required.</small>
  }
</div>
